import { Route, Routes } from "react-router-dom";
import { Box } from "@mui/material";
import EnrollmentIndex from "./Enrollment";
import OneClickEnrollment from "./OneClickEnrollment";

export default function ApplicationRecords() {

    return (
        <Box sx={{ display: 'flex', backgroundColor: 'background.default', minHeight: '100vh' }}>
            <Routes>
                <Route path="/enrollment/:appSchoolId/*" element={<EnrollmentIndex />} />
                <Route path='/one-click-enrollment/*' element={<OneClickEnrollment />} />
            </Routes>
        </Box>
    )
}